import isArray from './isArray';
import { createOptionalGuard } from './isOptional';

export default createOptionalGuard<unknown[]>(isArray);
